/**
 * Oct 20 (Issue 03A, FD-05) — confirm "Customer Picked Up" for a completed repair. Says exactly what the act
 * does: records who and when, releases the vehicle's bay or spot, and ends the shop's custody (the custody
 * history is kept). The act itself is mark_completed_ticket_picked_up (recordCompletedPickup).
 */
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export interface FohPickupConfirmDialogProps {
  open: boolean;
  subject: string | null;
  /** Where the vehicle is now ("Spot 12"), when known. */
  whereNow: string | null;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function FohPickupConfirmDialog({ open, subject, whereNow, busy, onConfirm, onCancel }: FohPickupConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o && !busy) onCancel(); }}>
      <AlertDialogContent className="max-w-md" data-testid="foh-pickup-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Customer picked up?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm">
              <p>{subject ? `Confirm that the customer has collected ${subject}.` : 'Confirm that the customer has collected this vehicle.'}</p>
              <ul className="list-disc pl-5 text-muted-foreground">
                <li>Records you and the time as the pickup.</li>
                <li>{whereNow ? `Releases ${whereNow}.` : 'Releases its bay or parking spot.'}</li>
                <li>Ends the shop’s custody of the vehicle (the handoff history is kept).</li>
              </ul>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-row">
          <AlertDialogCancel className="min-h-11" disabled={busy}>Cancel</AlertDialogCancel>
          <AlertDialogAction className="min-h-11" disabled={busy} data-testid="foh-pickup-confirm"
            onClick={(e) => { e.preventDefault(); onConfirm(); }}>
            {busy ? 'Recording…' : 'Customer picked up'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
